import { ACTION } from "src/util/utils";
import {
  KEYS,
  MODULE_KEY,
  MOVE_TO_PROCESSPO,
  MOVE_TO_PROCESSPO_SUCCESS,
  MOVE_TO_PROCESSPO_FAILED,
  UPLOAD_TO_VENDORPO,
  UPLOAD_TO_VENDORPO_SUCCESS,
  UPLOAD_TO_VENDORPO_FAILED,
} from "./actions";

export const REDUCER_KEY = KEYS[MODULE_KEY + ACTION.STATE_KEY];


export interface IFtpFileTransferState {
  loading: boolean;
  error: any;
  data: any[];
}

const defaultState: IFtpFileTransferState = {
  loading: false,
  error: null,
  data: [],
};

export const ftpFileTransferReducer = (
  state = defaultState,
  { type, payload }: any
) => {
  switch (type) {
    case MOVE_TO_PROCESSPO:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case MOVE_TO_PROCESSPO_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
        error: null,
      };
    case MOVE_TO_PROCESSPO_FAILED:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case UPLOAD_TO_VENDORPO:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPLOAD_TO_VENDORPO_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
        error: null,
      };
    case UPLOAD_TO_VENDORPO_FAILED:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
};
